import type { ConfigurationResponseDto } from '@api/WhisApi/configuration/configuration.types';
import AsyncStorage from '@react-native-async-storage/async-storage';

const CONFIGURATION_STORAGE_KEY = '@configuration/v1';

export const getStoredConfiguration =
  async (): Promise<ConfigurationResponseDto | null> => {
    try {
      const stored = await AsyncStorage.getItem(CONFIGURATION_STORAGE_KEY);
      if (!stored) {
        return null;
      }

      return JSON.parse(stored) as ConfigurationResponseDto;
    } catch (error) {
      console.error('Failed to read stored configuration', error);
      return null;
    }
  };

export const saveStoredConfiguration = async (
  configuration: ConfigurationResponseDto,
): Promise<void> => {
  try {
    await AsyncStorage.setItem(
      CONFIGURATION_STORAGE_KEY,
      JSON.stringify(configuration),
    );
  } catch (error) {
    console.error('Failed to persist configuration', error);
  }
};
